import { makeStyles, TextField } from '@material-ui/core';
import React from 'react';

const useStyles = makeStyles({
  label: {
    "& .MuiInputBase-input": {
      fontWeight: "bold"
    },
    "& .MuiFormLabel-root": {
      color: "#ffffff"
    },
    "& .MuiInputBase-root": {
      color: "#ffffff"
    },
    "& .MuiSelect-icon": {
      color: "#ffffff"
    }
  },
});

const MyInput = (props) => {
  const { handleChange, value, label, style, size, endAdornment } = props;
  const classes = useStyles();

  return (
    <>
      {
        props.disabled &&
        <TextField
          className={classes.label}
          label={label}
          value={value}
          style={{ ...style, backgroundColor: '#8ca0a8' }}
          size={size}
          color="secondary"
        />
      }
      {
        !props.disabled &&
        <TextField
          className={classes.label}
          onChange={(e) => handleChange(e)}
          onKeyPress={(e) => props.onKeyPress ? props.onKeyPress(e) : null}
          onBlur={(e) => props.onLeave ? props.onLeave(e) : null}
          label={label}
          value={value}
          style={style}
          size={size}
          color="secondary"
          InputProps={{endAdornment: endAdornment}}
        />
      }
    </>
  );

};

export default MyInput;